import { useTouch } from './use-touch';
import { getScrollParent } from './use-scroll-parent';
import { preventDefault } from '../utils/dom/event';
var lockCount = 0;
var BODY_LOCK_CLASS = 'pptmui-overflow-hidden';
export function useLockScroll(rootRef, isLock) {
    var touch = useTouch();
    var onTouchMove = function (event) {
        touch.move(event);
        var direction = touch.deltaY.current > 0 ? '10' : '01';
        var el = getScrollParent(event.target, rootRef.current);
        var scrollHeight = el.scrollHeight, offsetHeight = el.offsetHeight, scrollTop = el.scrollTop;
        var status = '11';
        if (scrollTop === 0) {
            status = offsetHeight >= scrollHeight ? '00' : '01';
        }
        else if (scrollTop + offsetHeight >= scrollHeight) {
            status = '10';
        }
        if (status !== '11' && touch.isVertical() && !(parseInt(status, 2) & parseInt(direction, 2))) {
            preventDefault(event, true);
        }
    };
    var lock = function () {
        if (isLock) {
            document.addEventListener('touchstart', touch.start);
            document.addEventListener('touchmove', onTouchMove, { passive: false });
            if (!lockCount) {
                document.body.classList.add(BODY_LOCK_CLASS);
            }
            lockCount++;
        }
    };
    var unLock = function () {
        if (isLock && lockCount) {
            document.removeEventListener('touchstart', touch.start);
            document.removeEventListener('touchmove', onTouchMove);
            lockCount--;
            if (!lockCount) {
                document.body.classList.remove(BODY_LOCK_CLASS);
            }
        }
    };
    return [lock, unLock];
}
